export function validateSessionId(sessionId: string): boolean {
  return typeof sessionId === 'string' && sessionId.length === 5 && /^[A-Za-z0-9]+$/.test(sessionId);
}

export function validateParticipantName(name: string): boolean {
  return typeof name === 'string' && name.trim().length > 0 && name.trim().length <= 50;
}

/**
 * Extracts session ID from a URL or returns the input if it's already a session ID.
 * Supports URLs like:
 * - http://localhost:3000/session/ABC12
 * - https://example.com/session/ABC12
 * - /session/ABC12
 * - ABC12 (returns as-is)
 *
 * @param input - Session ID or join URL
 * @returns Extracted session ID or original input if it's already a session ID
 */
export function extractSessionId(input: string): string {
  const trimmed = input.trim();
  
  // If it looks like a URL, try to extract the session ID
  if (trimmed.includes('/session/')) {
    // Match /session/:sessionId pattern
    const match = trimmed.match(/\/session\/([A-Za-z0-9]+)/);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  // If it's a full URL without /session/, check if it ends with a session ID
  // This handles edge cases where the URL might be malformed
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    const urlParts = trimmed.split('/');
    const lastPart = urlParts[urlParts.length - 1];
    // If the last part looks like a session ID, return it
    if (lastPart && lastPart.length === 5 && /^[A-Za-z0-9]+$/.test(lastPart)) {
      return lastPart;
    }
  }
  
  // Otherwise, return the trimmed input as-is (assuming it's a session ID)
  return trimmed;
}

